import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "report-summary-comp" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "clearfix flex-wrapper space-between vertical-center" }, [
  /*#__PURE__*/_createVNode("h2", null, "Report Summary")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", null, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-user" }),
  /*#__PURE__*/_createTextVNode(" User Info")
], -1)
const _hoisted_5 = { class: "destyled-list" }
const _hoisted_6 = /*#__PURE__*/_createVNode("strong", null, "Name:", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("strong", null, "User ID:", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("strong", null, "Email:", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("h2", null, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-tickets" }),
  /*#__PURE__*/_createTextVNode(" Report Details")
], -1)
const _hoisted_10 = { class: "destyled-list" }
const _hoisted_11 = /*#__PURE__*/_createVNode("strong", null, "Report Active:", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("strong", null, "Report ID:", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("strong", null, "Created:", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("h2", null, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-location-outline" }),
  /*#__PURE__*/_createTextVNode(" Location")
], -1)
const _hoisted_15 = { class: "destyled-list" }
const _hoisted_16 = /*#__PURE__*/_createVNode("strong", null, "Latitude:", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("strong", null, "Longitude:", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("View on Google Maps")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "box-card" }, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", null, [
            _hoisted_4,
            _createVNode("ul", _hoisted_5, [
              _createVNode("li", null, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.metadata.user_first_name) + " " + _toDisplayString(_ctx.metadata.user_last_name), 1)
              ]),
              _createVNode("li", null, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.metadata.user_id), 1)
              ]),
              _createVNode("li", null, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.metadata.user_email), 1)
              ])
            ])
          ]),
          _createVNode("div", null, [
            _hoisted_9,
            _createVNode("ul", _hoisted_10, [
              _createVNode("li", null, [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.report?.report_active), 1)
              ]),
              _createVNode("li", null, [
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_ctx.metadata.ap_report_id), 1)
              ]),
              _createVNode("li", null, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.convertDateString(
                  _ctx.metadata?.ap_report_created ?? _ctx.report?.date_created,
                  _ctx.userPrefs?.timezone,
                )), 1)
              ])
            ])
          ]),
          _createVNode("div", null, [
            _hoisted_14,
            _createVNode("ul", _hoisted_15, [
              _createVNode("li", null, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(_ctx.metadata.lat), 1)
              ]),
              _createVNode("li", null, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_ctx.metadata.lon), 1)
              ])
            ]),
            _createVNode(_component_el_link, {
              type: "primary",
              class: "footer-btn",
              href: 
              `https://www.google.com/maps?q=loc:${_ctx.metadata.lat},${_ctx.metadata.lon}`
            ,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}